import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-flex;\n\twidth: auto;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 100%;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-flex;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled } from '@wp-g2/styles';
export var ButtonGroupView = styled.div(_templateObject());
export var expanded = css(_templateObject2());
export var segmented = css(_templateObject3());